import { define } from "../preactement/define";
import { ThirdPartyExternalLink } from "../../ThirdPartyExternalLink";
import { analyticsOverrideAttrs, analyticsParentDataAttrs } from "../shared-attributes/analytics";
import { parseBooleanAttr } from "../wrapperUtils";
import { onAnalyticsEvent } from "../analytics";
import { jsx as _jsx } from "preact/compat/jsx-runtime";
const attributes = ['aria-described-by', 'href', 'class-name', 'learn-more-url', 'origin', ...analyticsOverrideAttrs, ...analyticsParentDataAttrs];
const Wrapper = _ref => {
  let {
    analytics,
    ...otherProps
  } = _ref;
  return /*#__PURE__*/_jsx(ThirdPartyExternalLink, {
    ...otherProps,
    analytics: analytics ? parseBooleanAttr(analytics) : undefined
  });
};

/* eslint-disable @typescript-eslint/no-namespace */

/* eslint-enable */

define('ds-third-party-external-link', () => Wrapper, {
  attributes,
  events: [onAnalyticsEvent]
});